import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { auditLogTimesheet } from 'src/api/teacher'

const useScreenTime = () => {
  const role = useSelector((state) => state.userDetails?.[0]?.profileType)
  const trackRef = useRef(true)
  const timeRef = useRef(Number(sessionStorage.getItem('screen_time')) || 0)
  const sendRef = useRef(false)
  useEffect(() => {
    if (role !== 'Teacher') return
    let timer = null
    const onVisibility = () => {
      trackRef.current = !document.hidden && document.hasFocus()
    }
    window.addEventListener('visibilitychange', onVisibility)
    window.addEventListener('focus', onVisibility)
    window.addEventListener('blur', onVisibility)

    const sendApi = async () => {
      if (sendRef.current) return
      sendRef.current = true
      const res = await auditLogTimesheet()
      if (res?.status === 'SUCCESS') {
        timeRef.current = 0
      }
      sendRef.current = false
    }

    timer = setInterval(() => {
      if (!trackRef.current) return
      timeRef.current++
      sessionStorage.setItem('screen_time', String(timeRef.current))
      if (timeRef.current >= 60) {
        sendApi()
      }
    }, 1000)

    return () => {
      clearInterval(timer)
      window.removeEventListener('visibilitychange', onVisibility)
      window.removeEventListener('focus', onVisibility)
      window.removeEventListener('blur', onVisibility)
    }
  }, [role])
}

export default useScreenTime
